import { render, staticRenderFns } from "./TestimonialButton.vue?vue&type=template&id=aef34020&scoped=true"
import script from "./TestimonialButton.vue?vue&type=script&lang=js"
export * from "./TestimonialButton.vue?vue&type=script&lang=js"
import style0 from "./TestimonialButton.vue?vue&type=style&index=0&id=aef34020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef34020",
  null
  
)

export default component.exports